class AbstractStockLocationController extends AbstractEntityEditController
	@inject 'stockLocation',
		'ConfigurationService'

	initialize: ->
		@mainCrud.isNewEntity = true
		@mainCrud.showFormActionButtons = false
		@mainCrud.entityType = 'general.stock.location'
		@mainCrud.entityTitle = 'wbo.new.stock.location'
		@mainCrud.showSave = @ConfigurationService.isEnabled 'Backoffice.StockManagement.StockLocations.EnableCreate'
		@mainCrud.showDelete = @ConfigurationService.isEnabled 'Backoffice.StockManagement.StockLocations.EnableDelete'

		if not _.isEmpty @stockLocation
			@mainCrud.isNewEntity = false
			@mainCrud.entityTitle = @stockLocation.name
			@mainCrud.showSave = @ConfigurationService.isEnabled 'Backoffice.StockManagement.StockLocations.EnableUpdate'
